// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "" + chunkId + "." + {"422":"b416e5bcac","748":"50f8489f0d"}[chunkId] + ".css";
};